import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HisAuthService } from 'hisng';

@Injectable()
export class ConferenceAuthService {

    constructor( private auth: HisAuthService ) { }

    public hasStatusAuthority(): boolean {
        if ( !this.auth.hasAny( 'RIGHT_FS_RES_PUBLICATION_EDIT_CONFERENCE_STATUS' ) ) {
            return false;   // the right is not present -> access denied
        }

        let statusParameterValue = this.auth.getRightsParameterValue(
            'RIGHT_FS_RES_PUBLICATION_EDIT_CONFERENCE_STATUS', '[Status].hiskeyId' );

        if ( !statusParameterValue ) {
            return true;    // no restriction -> access granted
        }

        // right is restricted -> access denied
        return false;
    }
}
